var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row text-center mt-5",staticStyle:{"min-height":"350px"}},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Bienvenido(a) "),(_vm.user.current)?_c('span',{staticClass:"name-text"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.getFullName))+" ")]):_vm._e(),_vm._v(" al portal de afiliación online. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }